import { memo } from "react";
import { 
    Row, 
    Col, 
    Form,
    Modal, 
    Button
} from "react-bootstrap"; 
import moment from "moment";

import style from './index.module.scss';

function ModalMaisDetalhes({
    dadosParticipante,
    dadosEvento,
    dadosCliente,
    aoFechar
}) {

    // prepara input para o modal
    const InputLabel = ({ label, valor }) => (
        <Col>
            <Form.Group>
                <Form.Label>{label}</Form.Label>
                <Form.Control 
                    value={valor}
                    disabled
                />
            </Form.Group>
        </Col>
    )

    // formata data de nascimento
    const dataNascimentoFormatada = moment(dadosParticipante.dataNascimento).format('DD/MM/YYYY');

    // loga com a carta oferta do cliente para ir para o evento
    function loginEvento() {

        // resgata servidor
        const { origin } = window.location
        
        // vai para a url designada para efetuar o login
        window.open(
            `${origin}/formularios/propostaSeguro/evento/${dadosEvento.token}?cartaOferta=${dadosCliente.cartaOferta || ''}`, 
            '_blank'
        );        

    }

    return (
        <Modal 
            show
            onExited={aoFechar}
            onHide={aoFechar}
            size={'lg'}
            className="fade"
            animation
            onBackdropClick={aoFechar}
        >
            <Modal.Header className='border-0 text-center'>
                <Modal.Title className="w-100">
                    Participante Sorteado - {dadosParticipante.nome}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-3">
                    <Col>
                        <b className={style.tituloSecao}>
                            Dados do Participante
                        </b>
                    </Col>
                </Row>
                <Row>
                    <InputLabel
                        label={"Nº Inscrição"}
                        valor={dadosParticipante.numeroInscricao}
                    />
                    <InputLabel
                        label={dadosParticipante.estrangeiro === "N" ? "CPF" : "Passaporte"}
                        valor={dadosParticipante.estrangeiro === "N" ? (dadosParticipante.cpf ?? "00000000000") : dadosParticipante.numeroPassaporte}
                    />
                    <InputLabel
                        label={"Nasc."}
                        valor={dataNascimentoFormatada}
                    />
                </Row>
                {(
                    dadosParticipante.dataEntrada &&
                    dadosParticipante.dataSaida
                ) && <Row>
                    <InputLabel
                        label={"Data Entrada"}
                        valor={moment(dadosParticipante.dataEntrada).format('DD/MM/YYYY')}
                    />
                    <InputLabel
                        label={"Data Saída"}
                        valor={moment(dadosParticipante.dataSaida).format('DD/MM/YYYY')}
                    />
                </Row>}
                <Row>
                    <InputLabel
                        label={"Email"}
                        valor={dadosParticipante.email ?? ''}
                    />
                    <InputLabel
                        label={"Telefone"}
                        valor={dadosParticipante.telefone ?? ''}
                    />
                </Row>
                <Row className="my-3">
                    <Col>
                        <b className={style.tituloSecao}>
                            Dados do Evento -
                        </b>
                        <button 
                            onClick={loginEvento}
                            className={style.botaoEvento}
                        >
                            <span>Ir para o evento</span>
                        </button>
                    </Col>
                </Row>
                <Row>
                    <InputLabel
                        label={"Código"}
                        valor={dadosEvento.codigo}
                    />
                    <InputLabel
                        label={"Nome"}
                        valor={dadosEvento.nomeEvento}
                    />
                </Row>
                {(
                    dadosEvento.dataInicio &&
                    dadosEvento.dataFinal
                ) && <Row>
                    <InputLabel
                        label={"Início"}
                        valor={moment(dadosEvento.dataInicio + ' ' + dadosEvento.horaInicio).format("DD/MM/YYYY [às] HH:mm[h]")}
                    />
                    <InputLabel
                        label={"Fim"}
                        valor={moment(dadosEvento.dataFinal + ' ' + dadosEvento.horaFinal).format("DD/MM/YYYY [às] HH:mm[h]")}
                    />
                </Row>}
                <Row className="my-3">
                    <Col>
                        <b className={style.tituloSecao}>
                            Dados do Cliente
                        </b>
                    </Col>
                </Row>
                <Row>
                    <InputLabel
                        label={"Nome"}
                        valor={dadosCliente.nome ?? ''}
                    />
                    <InputLabel
                        label={"Código de Referência"}
                        valor={dadosCliente.cartaOferta ?? ''}
                    />
                </Row>
                <Row>
                    <InputLabel
                        label={dadosCliente.tipoPessoa === 'F' ? "CPF" : "CNPJ"}
                        valor={dadosCliente.tipoPessoa === 'F' ? dadosCliente.cpf : dadosCliente.cnpj}
                    />
                    <InputLabel
                        label={"Nº Apólice"}
                        valor={dadosCliente.numeroApolice ?? ''}
                    />
                </Row>
                <Row>
                    <InputLabel
                        label={"Email"}
                        valor={dadosCliente.email ?? ''}
                    />
                    <InputLabel
                        label={"Telefone Celular"}
                        valor={dadosCliente.telefoneCelular ?? ''}
                    />
                </Row>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <Button
                    variant='padrao'
                    onClick={aoFechar}
                >
                    <span>Fechar</span>
                </Button>
            </Modal.Footer>
        </Modal>
    )

}

export default memo(ModalMaisDetalhes);